import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * RepresentativesApi - axios parameter creator
 * @export
 */
const RepresentativesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/Representatives/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingStatistics: async (representativeId, options = {}) => {
            const localVarPath = `/v1/Representatives/GetBookingStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (representativeId !== undefined) {
                localVarQueryParameter['representativeId'] = representativeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Representatives/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [position]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPosition: async (position, options = {}) => {
            const localVarPath = `/v1/Representatives/GetByPosition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (RepresentativeToken, options = {}) => {
            const localVarPath = `/v1/Representatives/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RepresentativeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Representatives/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (searchText, options = {}) => {
            const localVarPath = `/v1/Representatives/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (RepresentativeToken, options = {}) => {
            const localVarPath = `/v1/Representatives/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RepresentativeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RepresentativesApi - functional programming interface
 * @export
 */
const RepresentativesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RepresentativesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingStatistics(representativeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingStatistics(representativeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.getBookingStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [position]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPosition(position, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPosition(position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.getByPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(RepresentativeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(RepresentativeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(searchText, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(searchText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(RepresentativeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(RepresentativeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RepresentativesApi - factory interface
 * @export
 */
const RepresentativesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RepresentativesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingStatistics(representativeId, options) {
            return localVarFp.getBookingStatistics(representativeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [position]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPosition(position, options) {
            return localVarFp.getByPosition(position, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(RepresentativeToken, options) {
            return localVarFp.insert(RepresentativeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(searchText, options) {
            return localVarFp.search(searchText, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeToken} [RepresentativeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(RepresentativeToken, options) {
            return localVarFp.update(RepresentativeToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RepresentativesApi - object-oriented interface
 * @export
 * @class RepresentativesApi
 * @extends {BaseAPI}
 */
class RepresentativesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    getAll(options) {
        return RepresentativesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [representativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    getBookingStatistics(representativeId, options) {
        return RepresentativesApiFp(this.configuration).getBookingStatistics(representativeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    getById(id, options) {
        return RepresentativesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {string} [position]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    getByPosition(position, options) {
        return RepresentativesApiFp(this.configuration).getByPosition(position, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {RepresentativeToken} [RepresentativeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    insert(RepresentativeToken, options) {
        return RepresentativesApiFp(this.configuration).insert(RepresentativeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    remove(id, options) {
        return RepresentativesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {string} [searchText]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    search(searchText, options) {
        return RepresentativesApiFp(this.configuration).search(searchText, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {RepresentativeToken} [RepresentativeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativesApi
     */
    update(RepresentativeToken, options) {
        return RepresentativesApiFp(this.configuration).update(RepresentativeToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { RepresentativesApi, RepresentativesApiAxiosParamCreator, RepresentativesApiFactory, RepresentativesApiFp };
//# sourceMappingURL=representatives-api.js.map
